import Link from '../Link';
import plugins from './plugins';

export default class EditorLink extends Link {
  plugins = plugins;
}
